import { loadStripe, Stripe } from "@stripe/stripe-js";
import { setCreateAddMoneyStatus } from "actions/balance";
import { call, put, takeLeading } from "redux-saga/effects";
import handleNetworkError from "sagas/helpers/handleNetworkError";
import { post } from "sagas/helpers/network";

const stripeKey = process.env.REACT_APP_STRIPE_KEY as string;

function* execute(action: sage.actions.balance.ICreateAddMoney) {
    yield put(setCreateAddMoneyStatus("loading"));
    try {
        const stripe: Stripe | null = yield call(loadStripe, stripeKey);
        if (!stripe) {
            yield put(setCreateAddMoneyStatus("error"));
            return;
        }
        const response = yield post("/create-add-money-session", {
            amount_cent_hundredths: action.centHundredths,
        });
        if (response.data && response.data.id) {
            const id = response.data.id;
            const result = yield call(stripe.redirectToCheckout, {
                sessionId: id,
            }) as any;
            if (result.error) {
                yield put(setCreateAddMoneyStatus("error"));
                return;
            }
            yield put(setCreateAddMoneyStatus("none"));
        } else {
            yield put(setCreateAddMoneyStatus("error"));
        }
    } catch (e) {
        yield handleNetworkError(e);
        yield put(setCreateAddMoneyStatus("error"));
    }
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.balance.ICreateAddMoney", execute);
}
